module.exports = __webpack_public_path__ + "img/whitemask.bd1a5517.png";